import {
	IonCard,
	IonCardContent,
	IonItem,
	IonList,
	IonSelect,
	IonSelectOption,
} from "@ionic/react";
import { useHistory, useParams } from "react-router";
import WithFab from "../../hoc/with-fab";
import WithNavigation from "../../hoc/with-navigation";
import { home } from "ionicons/icons";
import TvmForm from "../../components/common/tvm-form";
import { useSystem } from "../../store/system";
import { useEffect, useState } from "react";
import { TvmFormSubmitResult } from "../../components/common/tvm-form/form-definition";
import { printNumber } from "../../utils/helpers";
import InfoImg from "../../components/info-image";

import "./styles.css";
import { useTranslation } from "react-i18next";

const FORM_ID = "guinches";

interface GuinchesResult {
	guincheResult: number | null;
}

type GuincheType = "A" | "B";

const Guinches = () => {
	const { systemId } = useParams<any>();
	const history = useHistory();

	const systemStore = useSystem();

	const { t } = useTranslation();

	const updateResults = (data: TvmFormSubmitResult<GuinchesResult>) => {
		systemStore.submitFormResult(systemId, FORM_ID, data);
	};

	const [guincheType, setGuincheType] = useState<GuincheType>("A");

	useEffect(() => {
		systemStore.loadForm(FORM_ID);
		systemStore.loadFormResult(systemId, FORM_ID);
	}, []);

	return (
		<>
			<WithNavigation
				hintsContent={{
					title: systemStore.currentForm?.hints.title,
					htmlDef: systemStore.currentForm?.hints?.htmlDef || "",
				}}
				preventGoBack={false}
				text={t("system.guinches.title")}
			>
				<InfoImg imgSrc="/assets/guinches.jpeg"/>
				<div className="form">
					<IonList lines="none">
						<IonItem>
							<IonSelect
								value={guincheType}
								placeholder={t("system.guinches.type.selectPlaceholder")}
								onIonChange={(e) => setGuincheType(e.detail.value)}
								okText="Aceptar"
								cancelText="Cancelar"
							>
								<IonSelectOption value="A">{t("system.guinches.type.A")}</IonSelectOption>
								<IonSelectOption value="B">{t("system.guinches.type.B")}</IonSelectOption>
							</IonSelect>
						</IonItem>
					</IonList>
					{systemStore.currentForm && (
						<>
							{systemStore.formResultReqInfo?.finished && (
								<TvmForm
									title={t("system.guinches.title")}
									systemName={systemId}
									definition={systemStore.currentForm}
									fieldValues={systemStore.currentFormValues}
									onSubmit={updateResults}
								/>
							)}
							{guincheType === "A" && (
								<IonCard>
									<IonCardContent>
										<div className="ion-text-center">
											<h5 className="calcResultTitle">{t("general.results")}</h5>
											<div className="result-row">
												<p className="label">{t("system.guinches.guincheCapacity")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.guincheCapacity)}
												</p>
												<p>[m]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.cableWeight")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.cableWeight)}
												</p>
												<p>[kg]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.guincheCapacity90Percent")}</p>
												<p className="row-value">
													{printNumber(
														0.9 * systemStore.formResult?.guincheCapacity
													)}
												</p>
												<p>[m]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.cableWeight90Percent")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.cableWeight90)}
												</p>
												<p>[m]</p>
											</div>
										</div>
									</IonCardContent>
								</IonCard>
							)}
							{guincheType === "B" && (
								<IonCard>
									<IonCardContent>
										<div className="ion-text-center">
											<h5 className="calcResultTitle">{t("general.results")}</h5>
											<div className="result-row">
												<p className="label">{t("system.guinches.guincheCapacity")}</p>
												<p className="row-value">
													{printNumber(
														systemStore.formResult?.guincheCapacityB
													)}
												</p>
												<p>[mm]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.cableWeight")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.cableWeightB)}
												</p>
												<p>[kg]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.guincheCapacity90Percent")}</p>
												<p className="row-value">
													{printNumber(
														0.9 * systemStore.formResult?.guincheCapacityB
													)}
												</p>
												<p>[m]</p>
											</div>
											<div className="result-row">
												<p className="label">{t("system.guinches.cableWeight90Percent")}</p>
												<p className="row-value">
													{printNumber(systemStore.formResult?.cableWeight90)}
												</p>
												<p>[m]</p>
											</div>
										</div>
									</IonCardContent>
								</IonCard>
							)}
						</>
					)}
				</div>
			</WithNavigation>
		</>
	);
};

export default Guinches;
